import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {

  constructor(private rest: RestService) { }

  public getOrgStructure(orgId: string): any {
    return this.rest.get("getOrgStructure", orgId);
  }

  public getOrgStructureByUsername(username: string): any {
    return this.rest.get("getOrgStructureByUsername", username);
  }

  public getDepartmentById(id: string): any {
    return this.rest.get("getDepartmentById", id);
  }

  public deleteDepartmentById(id: string): any {
    return this.rest.delete("deleteDepartment", id);
  }

  public addDepartment(form: FormGroup, parentId: string, parentType: string): any {
    const body = this.mapDepData(form, parentId, parentType);
    return this.rest.post("addDepartment", body);
  }

  mapDepData(form: FormGroup, parentId: string, parentType: string): any {
    let dep = {};
    dep["parent_id"] = parentId;
    dep["parent_type"] = parentType;
    dep["name"] = form.controls.name.value;
    dep["desc"] = form.controls.desc.value;
    return dep;
  }

  public editDepartment(form: FormGroup, data: any): any {
    const body = this.mapEditDepData(form, data);
    return this.rest.put("editDepartment", body);
  }

  mapEditDepData(form: FormGroup, dep: any): any {
    dep["name"] = form.controls.name.value;
    dep["desc"] = form.controls.desc.value;
    return dep;
  }
}
